module.exports = __webpack_public_path__ + "img/jumpserver.7d30e7c6.png";